import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { NgClass, NgOptimizedImage } from '@angular/common';
import { AuthService } from '../auth.service';
import { assetUrl } from '@app/shared/utils/asset-url.util';

@Component({
  selector: 'app-forgot-password',
  imports: [FormsModule, NgOptimizedImage, NgClass, RouterLink],
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.css'
})
export class ForgotPasswordComponent {
  email = '';
  protected error?: string = undefined;
  protected success?: string = undefined;
  protected submitting = false;
  protected readonly logoUrl = assetUrl('images/the-venue-group-logo.svg');

  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  submit() {
    this.error = undefined;
    this.success = undefined;
    this.submitting = true;

    this.authService.forgotPassword(this.email).subscribe({
      next: (response) => {
        this.submitting = false;
        // TVG-333: the same answer whether or not the email is registered.
        this.success = response.message || "If that email address is registered with us, we've sent a link to set a new password.";
        this.email = '';
      },
      error: (response) => {
        this.submitting = false;
        this.error = response.error?.message || 'Unable to send reset link. Please try again.';
      }
    });
  }
}
